import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useTrpc } from '~/composables/_next/useTrpc';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useSlug } from '~/composables/useSlug';
import useRightPath from '~/composables/useRightPath';
import useProductContent from '~/composables/useProductContent/useProductContent';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useAdviceStore() {
  var _useNuxt2App = useNuxt2App(),
    i18n = _useNuxt2App.i18n;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var route = useRoute();
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useSlug = useSlug(),
    transformSlugsForSeo = _useSlug.transformSlugsForSeo;
  var _useLegacySeoMeta = useLegacySeoMeta(),
    setMeta = _useLegacySeoMeta.setMeta;
  var _useRightPath = useRightPath(),
    getDomain = _useRightPath.getDomain;
  var _useProductContent = useProductContent(),
    mapComponentName = _useProductContent.mapComponentName;

  /**
   * Stores the current advice from contentful
   */
  var advice = useState("advice-".concat(route.params.slug), function () {
    return null;
  });
  var adviceContent = useState("advice-content-".concat(route.params.slug), function () {
    return null;
  });

  /**
   * Stores the current related content from contentful
   */
  var adviceRelatedContent = useState("advice-related-content-".concat(route.params.slug), function () {
    return null;
  });
  var components = useState("advice-content-".concat(route.params.slug), function () {
    return null;
  });

  /**
   * Fetches the advice minimal data from contentful.
   */
  function fetchAdvice() {
    return _fetchAdvice.apply(this, arguments);
  }
  /**
   * Fetches the advice content contentful as the request is currently to big for GraphQL.
   * @todo: Refactor this to use GraphQL when the request is fixed.
   */
  function _fetchAdvice() {
    _fetchAdvice = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _data$mainImage, _data$author, _data$seo$ogTitle, _data$seo, _data$mainImage2;
      var data, jsonld, socialMeta;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.advice.fetch.query({
              slug: route.params.slug,
              locale: locale
            });
          case 2:
            data = _context.sent;
            jsonld = {
              '@context': 'https://schema.org',
              '@graph': [{
                '@type': 'NewsArticle',
                'url': route.path,
                'image': [data === null || data === void 0 ? void 0 : (_data$mainImage = data.mainImage) === null || _data$mainImage === void 0 ? void 0 : _data$mainImage.url],
                'publisher': {
                  '@type': 'Organization',
                  'name': 'Aroma Zone',
                  'logo': 'https://www.aroma-zone.com/favicon.svg'
                },
                'headline': data === null || data === void 0 ? void 0 : data.title,
                'wordCount': data === null || data === void 0 ? void 0 : data.wordCount,
                'datePublished': data.sys.firstPublishedAt,
                'dateModified': data.sys.publishedAt,
                'author': {
                  '@type': 'Person',
                  'name': (_data$author = data.author) === null || _data$author === void 0 ? void 0 : _data$author.fullName
                }
              }]
            };
            socialMeta = [{
              property: 'og:title',
              content: (_data$seo$ogTitle = data === null || data === void 0 ? void 0 : (_data$seo = data.seo) === null || _data$seo === void 0 ? void 0 : _data$seo.ogTitle) !== null && _data$seo$ogTitle !== void 0 ? _data$seo$ogTitle : data.title
            }, {
              property: 'og:image',
              content: data === null || data === void 0 ? void 0 : (_data$mainImage2 = data.mainImage) === null || _data$mainImage2 === void 0 ? void 0 : _data$mainImage2.url
            }, {
              property: 'og:url',
              content: "".concat(getDomain()).concat(route.path)
            }, {
              property: 'twitter:card',
              content: 'summary_large_image'
            }, {
              property: 'twitter:title',
              content: data.title
            }, {
              property: 'og:type',
              content: 'article'
            }];
            setMeta(_objectSpread(_objectSpread({}, data.seo), {}, {
              socialMeta: socialMeta,
              slug: transformSlugsForSeo(data),
              largePreview: true,
              jsonld: jsonld
            }));
            advice.value = data;
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchAdvice.apply(this, arguments);
  }
  function fetchAdviceContent() {
    return _fetchAdviceContent.apply(this, arguments);
  }
  /**
   * Fetches the related content from contentful.
   */
  function _fetchAdviceContent() {
    _fetchAdviceContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.contentful.getEntries.query({
              params: {
                locale: locale,
                'content_type': 'pageAdvice',
                'fields.slug': route.params.slug,
                'include': 0,
                'select': ['fields.contents']
              },
              nestedFields: ['contents']
            });
          case 2:
            data = _context2.sent;
            adviceContent.value = data.items[0].fields.contents;
            components.value = mapComponentName(data.items[0].fields.contents);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _fetchAdviceContent.apply(this, arguments);
  }
  function fetchAdviceRelatedContent() {
    return _fetchAdviceRelatedContent.apply(this, arguments);
  }
  function _fetchAdviceRelatedContent() {
    _fetchAdviceRelatedContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return client.advice.fetchRelated.query({
              slug: route.params.slug,
              locale: locale
            });
          case 2:
            data = _context3.sent;
            adviceRelatedContent.value = data;
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _fetchAdviceRelatedContent.apply(this, arguments);
  }
  function fetchAllAdviceContent() {
    return _fetchAllAdviceContent.apply(this, arguments);
  }
  function _fetchAllAdviceContent() {
    _fetchAllAdviceContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all([fetchAdvice(), fetchAdviceContent(), fetchAdviceRelatedContent()]);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _fetchAllAdviceContent.apply(this, arguments);
  }
  var relatedAdvices = computed(function () {
    var _adviceRelatedContent;
    var advices = ((_adviceRelatedContent = adviceRelatedContent.value) === null || _adviceRelatedContent === void 0 ? void 0 : _adviceRelatedContent.advices) || [];
    return advices === null || advices === void 0 ? void 0 : advices.filter(function (advice) {
      return advice === null || advice === void 0 ? void 0 : advice.slug;
    });
  });
  var relatedRecipes = computed(function () {
    var _adviceRelatedContent2;
    var recipes = ((_adviceRelatedContent2 = adviceRelatedContent.value) === null || _adviceRelatedContent2 === void 0 ? void 0 : _adviceRelatedContent2.recipes) || [];
    return recipes === null || recipes === void 0 ? void 0 : recipes.filter(function (recipe) {
      return recipe === null || recipe === void 0 ? void 0 : recipe.slug;
    });
  });
  var relatedProducts = computed(function () {
    var _adviceRelatedContent3;
    var products = ((_adviceRelatedContent3 = adviceRelatedContent.value) === null || _adviceRelatedContent3 === void 0 ? void 0 : _adviceRelatedContent3.products) || [];
    return products;
  });
  var isFlattened = computed(function () {
    var _advice$value;
    return ((_advice$value = advice.value) === null || _advice$value === void 0 ? void 0 : _advice$value.flatStructure) || false;
  });
  return {
    advice: advice,
    adviceContent: adviceContent,
    adviceRelatedContent: adviceRelatedContent,
    components: components,
    fetchAdvice: fetchAdvice,
    fetchAdviceContent: fetchAdviceContent,
    fetchAdviceRelatedContent: fetchAdviceRelatedContent,
    fetchAllAdviceContent: fetchAllAdviceContent,
    relatedAdvices: relatedAdvices,
    relatedRecipes: relatedRecipes,
    relatedProducts: relatedProducts,
    isFlattened: isFlattened
  };
}